/**
 * buildComponentProps
 *
 * Assembles the large props object that is spread into the rendered
 * POS component (<RenderComponent />, <CoreModals />, <ReturnBill />,
 * <PointOfSuperMarketModals />) and all their children.
 *
 * Accepts an object with all hook results and local values, then
 * builds the flat prop object expected by child components.
 *
 * The renames (e.g. realPriceFromCart -> realPrice) are done here
 * so callers can just pass hook results directly.
 */
export const buildComponentProps = (ctx) => {
  // Handle aliased fields from cart operations
  const {
    firstInputValueFromCart,
    setFirstInputValueFromCart,
    realPriceFromCart,
    setRealPriceFromCart,
    ...rest
  } = ctx;

  return {
    ...rest,
    // Aliased fields that downstream components expect
    firstInputValue: firstInputValueFromCart ?? rest.firstInputValue,
    setFirstInputValue: setFirstInputValueFromCart ?? rest.setFirstInputValue,
    realPrice: realPriceFromCart ?? rest.realPrice,
    setRealPrice: setRealPriceFromCart ?? rest.setRealPrice,
  };
};
